import FeatureReferenceSourceType from './FeatureReferenceSourceType.js';
const KEY_SEPARATOR = ':';
/**
 * @memberof feature-references
 * @property {feature-references.FeatureReferenceSourceType} type
 * @property {number} sourceId
 * @property {number} id
 */
class FeatureReference {
    /**
     * @param {object} props
     * @param {feature-references.FeatureReferenceSourceType} props.type
     * @param {number} props.sourceId
     * @param {number} props.id
     */
    constructor(props) {
        this.type = props.type;
        this.sourceId = props.sourceId;
        this.id = props.id;
    }
    /**
     * @param {feature-references.FeatureReference} ref
     * @return {boolean}
     */
    isEqual(ref) {
        return ref.key === this.key;
    }
    /**
     * @type {string}
     */
    get key() {
        return [this.type, this.sourceId, this.id].join(KEY_SEPARATOR);
    }
    /**
     * @param {string} key
     * @return {feature-references.FeatureReference}
     */
    static fromKey(key) {
        const [type, sourceId, id] = key.split(KEY_SEPARATOR);
        return new FeatureReference({ type: FeatureReferenceSourceType[type], sourceId: parseInt(sourceId, 10), id: parseInt(id, 10) });
    }
    /**
     * @param {object} props
     * @returns {feature-references.FeatureReference}
     */
    static fromJSON(props) {
        return new FeatureReference(props);
    }
}
/**
 * @type {feature-references.FeatureReferenceSourceType}
 */
FeatureReference.SourceType = FeatureReferenceSourceType;
export default FeatureReference;
